import React, {lazy, Suspense } from 'react';
import Dashboard from '../../components/Dashboard/Dashboard';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const MyOrder = lazy(()=>import('../../components/Dashboard/MyOrder/MyOrder'))

const MyOrderPage = () => {
    return (
        <Dashboard>
            <Suspense fallback={<LazyLoader/>}>
                <MyOrder/>
            </Suspense>
        </Dashboard>
    );
};

export default MyOrderPage;